import { fnProxy } from 'snek-query';
export class Query {
    constructor() {
        this.__typename = '';
        this.version = '';
    }
}
export class Mutation {
    constructor() {
        this.__typename = '';
        this.publish = fnProxy(PublishEvent);
    }
}
export class PublishEvent {
    constructor() {
        this.__typename = '';
        this.publishedDate = '';
        this.repositoryPath = '';
    }
}
